"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  z50: "#FAF5F3",
  z100: "#EBD9D2",
  z200: "#C49C8E",
  z300: "#B57962",
  z400: "#A45C41",
  z500: "#864129",
  z600: "#64311E",
  z700: "#41251B",
  z800: "#341B12",
  z900: "#29120A"
};